export class ComponentEntryComplexityRole {
  id!: number
  name!: string
  complexity!: string
  disciplineTypeName!: string
  rateCardNameAndVersion!: string
  componentModifierName?: string
  formula?: string
}
